const filterTools = {
    submitFilters: function (typePage = false, removeFilters = false) {
        const urlParams = new URLSearchParams(window.location.search);
        const page = parseInt(urlParams.get('page')) || 1;

        var array = {};
        array.series = [];
        array.brands = []; // Добавляем массив для брендов
        array.vals = []; // Массив для характеристик
        array.min_price = '';
        array.max_price = '';

        // Обработка чекбоксов брендов
        $(".js_filter_brand").each(function () {
            if ($(this).is(":checked")) {
                array.brands.push($(this).val());
            }
        });

        // Обработка чекбоксов серий
        $(".js_filter_series").each(function () {
            if ($(this).is(":checked")) {
                array.series.push($(this).val());
            }
        });

        // Обработка чекбоксов характеристик
        $(".js_filter_char").each(function () {
            if ($(this).is(":checked")) {
                let idChar = $(this).val();
                let idParentChar = $(this).attr('data-idGroupChar');
                // Формируем значение в формате "idParentChar_idChar"
                array.vals.push(`${idParentChar}_${idChar}`);
            }
        });

        // Обработка цен
        var selected_min_price = parseFloat($('#input_min_price').val());
        var start_min_price = parseFloat($('#input_min_price').attr('data-start-min'));
        var selected_max_price = parseFloat($('#input_max_price').val());
        var start_max_price = parseFloat($('#input_max_price').attr('data-start-max'));

        if (!isNaN(selected_max_price) && selected_max_price !== start_max_price) {
            array.max_price = selected_max_price;
        } else {
            if (!isNaN(selected_min_price) && selected_min_price !== start_min_price) {
                array.max_price = start_max_price;
            } else {
                delete array.max_price;
            }
        }
        if (!isNaN(selected_min_price) && selected_min_price !== start_min_price) {
            array.min_price = selected_min_price;
        } else {
            delete array.min_price;
        }

        // Удаление пустых массивов
        if (array.brands.length < 1) {
            delete array.brands;
        }
        if (array.series.length < 1) {
            delete array.series;
        }
        if (array.vals.length < 1) {
            delete array.vals;
        }

        let filters;
        if (removeFilters) {
            filters = "luru";
        } else {
            filters = JSON.stringify(array);
            filters = filters
                .replace(/}/g, 'ru')
                .replace(/{/g, 'lu')
                .replace(/"/g, 'kv')
                .replace(/:/g, 'dv')
                .replace(/,/g, 'zp')
                .replace(/]/g, 'rk')
                .replace(/\[/g, 'lk');
        }

        let url = main_url;

        if (typePage !== 'search') {
            if (filters !== "luru") {
                url = url + "?filters=" + filters;
                if (sorting !== '' && sorting !== 'default') {
                    url = url + "&sorting=" + sorting;
                }
                if (page > 1) {
                    url = url + (filters === "" && sorting === "" ? "?" : "&") + "page=" + page;
                }
            } else {
                filters = "";
                if (sorting !== '' && sorting !== 'default') {
                    url = url + "?sorting=" + sorting;
                    if (page > 1) {
                        url = url + "&page=" + page;
                    }
                } else if (page > 1) {
                    url = url + "?page=" + page;
                }
            }
        } else {
            if (filters !== "luru") {
                url = url + "&filters=" + filters;
                if (sorting !== '' && sorting !== 'default') {
                    url = url + "&sorting=" + sorting;
                }
                if (page > 1) {
                    url = url + "&page=" + page;
                }
            } else {
                filters = "";
                if (sorting !== '' && sorting !== 'default') {
                    url = url + "&sorting=" + sorting;
                    if (page > 1) {
                        url = url + "&page=" + page;
                    }
                } else if (page > 1) {
                    url = url + "&page=" + page;
                }
            }
        }

        history.pushState({}, '', url);

        let requestloadGoods = '';
        const objectLoad = {
            "lang": lang,
            "cat_id": cat_id,
            "brand_id": brand_id,
            "series_id": series_id,
            "search": query || null,
            "sorting": sorting || null,
            "filters": filters || null,
            "page": page
        };

        switch (typePage) {
            case 'search':
                requestloadGoods = requests.searchLoadGoods;
                objectLoad.query = query;
                break;
            default:
                requestloadGoods = requests.loadGoods;
                objectLoad.cat_id = (cat_id != "") ? cat_id : "";
                break;
        }

        $.post(requestloadGoods, objectLoad, function (data) {
            if (data.status === 'success') {
                $('.js__goods').empty().append(data.html);
                filterTools.loadFilters({
                    cat_id: cat_id,
                    brand_id: brand_id,
                    series_id: series_id,
                    filters: filters,
                    sorting: sorting,
                    query: query,
                });
            }
        });
    },

    loadFilters: function (dataValues) {
        $.post(requests.loadFilters, {
            'cat_id': dataValues.cat_id,
            "brand_id": dataValues.brand_id,
            "series_id": dataValues.series_id,
            'filters': dataValues.filters,
            'sorting': dataValues.sorting,
            'search': dataValues.query,
            'lang': lang
        }, function (data) {
            if (data.status === 'ok') {
                $('.js_filter_scroll').empty().append(data.html);
                filterTools.sliderInit()
                filterTools.checkActive()
            }
        });
    },

    displayFilterValues(button) {
        button.toggleClass('active')
    },

    sliderInit() {
        const slider = $('.js_filters__prices-slider')
        const min = Math.round(slider.attr('data-min'))
        const max = Math.round(slider.attr('data-max'))
        const valMin = Math.round(slider.attr('data-val-min'))
        const valMax = Math.round(slider.attr('data-val-max'))

        noUiSlider.create(slider[0], {
            start: [valMin, valMax],
            connect: true,
            range: {
                'min': min,
                'max': max
            },
            step: 1,
        })

        slider[0].noUiSlider.on('update', function (values) {
            const slider = $(this.target).closest('.js_filters__prices-slider')
            const defaultMin = Math.round(slider.attr('data-min'))
            const defaultMax = Math.round(slider.attr('data-max'))
            const min = Math.round(values[0])
            const max = Math.round(values[1])
            $('#input_min_price').val(min != defaultMin ? min : '')
            $('#input_max_price').val(max != defaultMax ? max : '')
        });
    },

    setPriceInputs(type) {
        const slider = $('.js_filters__prices-slider')[0]
        const inputMin = $('#input_min_price')
        const inputMax = $('#input_max_price')
        const defaultMin = Math.round(inputMin.attr('data-start-min'))
        const defaultMax = Math.round(inputMax.attr('data-start-max'))
        const valMin = inputMin.val() != '' ? Math.round(inputMin.val()) : defaultMin
        const valMax = inputMax.val() != '' ? Math.round(inputMax.val()) : defaultMax
        let sliderMin = valMin
        let sliderMax = valMax
        console.log(valMin, valMax)
        if (type == 'min') {
            console.log(type)
            if (valMin <= defaultMin) {
                inputMin.val('')
                sliderMin = defaultMin
            } else if (valMin > valMax) {
                inputMin.val(valMax)
                sliderMin = valMax
            }
        }
        if (type == 'max') {
            console.log(type)
            if (valMax >= defaultMax) {
                inputMax.val('')
                sliderMax = defaultMax
            } else if (valMax < valMin) {
                inputMax.val(valMin)
                sliderMax = valMin
            }
        }
        slider.noUiSlider.set([sliderMin, sliderMax])
    },

    checkActive() {
        $('.js_filters__item-title').each((i, el) => {
            const list = $(el).next('.js_filter_list')
            if (list.find('input:checked').length) {
                $(el).addClass('active')
            }
        })
    },

    removeFilters(button) {
        const type = button.attr('data-type')
        const id = button.attr('data-id')
        const group = button.attr('data-namegroup')

        switch (type) {
            case 'char':   
                $(`input[value=${id}][data-idgroupchar=${group}]`).prop('checked', false)
                break;
            case 'price':
                $('#input_min_price, #input_max_price').val('')
                break;
            case 'brand':
                $(`input[value=${id}][data-type=brand], input[data-brand_id=${id}]`).prop('checked', false)
                break;
            case 'series':
                $(`input[value=${group}_${id}][data-type=series]`).prop('checked', false)
                break;
        }

        filterTools.submitFilters(
            type_page,
        );
    }
};


$(document).ready(function () {
    $(document).on('change', '.js_filter_checbox', function () {
        if ($(this).hasClass('js_filter_brand') && !$(this).is(':checked')) {
            const brandId = $(this).val();
            $(`.js_filter_series[data-brand_id="${brandId}"]`).prop('checked', false);
        }
        filterTools.submitFilters(
            type_page,
        );
    });

    $(document).on('click', '#do_price_range', function (e) {
        e.preventDefault();
        filterTools.submitFilters(
            type_page,
        );
    });

    $(document).on('click', '.js__clear_filter', function () {
        filterTools.submitFilters(
            type_page,
            true
        );
    })

    $(document).on('click', '.js_filters__item-title', function () {
        filterTools.displayFilterValues($(this))
    })

    $(document).on('blur', '#input_min_price', function () {
        filterTools.setPriceInputs('min')
    })

    $(document).on('blur', '#input_max_price', function () {
        filterTools.setPriceInputs('max')
    })

    $(document).on('click', '.js_filters__remove', function () {
        filterTools.removeFilters($(this))
    })
})

window.loadFilters = filterTools.loadFilters;